import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'commaSeparatedProperty' })

export class CommaSeparatedProperty implements PipeTransform {
	constructor() { }

	transform(list: any[], field: string): string {
		let ret = '';

		if (!list || list.length === 0) {
			return ret;
		}
		const length = list.length;
		for (let i = 0; i < length; i++) {
			if (list[i]) {
				const val = list[i][field];
				if (val != null) {
					ret += val;
					if (i < length - 1) {
						ret += ', ';
					}
				}
			}
		}
		return ret;
	}
}
